import { useState, useEffect, useRef } from 'react';
import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import {useNavigate} from 'react-router-dom';
import GeneralInformationTable from './GeneralInformationTable';
import imgLogo from './Portal_PWC.png';
import rightLogo from './right_bar.jpg';
import { useAuth } from 'oidc-react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


function NewScrapEvaluation() 
{
  const auth = useAuth();
  const [configJsonFile, setConfigJsonFile] =useState();

  useEffect(()=>{
    const fetchData = async()=>{
      try{
        const response = await fetch(`${process.env.PUBLIC_URL}/Config.json`);        
        const data= await response.json();
        setConfigJsonFile(data);           
        console.log("Json file read from the Public folder completed:");                      
      }catch(error){
        console.error('Error fetching Config JSON file data:',error);
      }
    }    
    fetchData();    
  },[]);
  useEffect(()=>{
    if(configJsonFile!="undefined"){
      //getCSRFToken();
    }   
  },[configJsonFile]);

  const navigate = useNavigate();  
  const [apimessage, setAPIMessage] = useState('');
  const [modelPopupshow, setmodelPopupshow] = useState(false);
    
  const [comments, setComments] = useState("");  
  const [selectedFile, setSelectedFile] = useState([]);
  const [VendorCode, setVendorCode] = useState("");
  const [VendorName, setVendorName] = useState("");
  const [VendorEmail, setVendorEmail] = useState("");
  const [ContactName, setContactName] = useState("");
  const [Telephone, setTelephone] = useState("");
  const [QualityManager, setQualityManager] = useState("");
  const [DateValue, setDateValue] = useState(new Date().toISOString().split('T')[0]);
  const [PWC_Representative, setPWC_Representative] = useState("");
  const [rowsData, setRowsData] = useState([]);
  const [isChecked,setIsChecked]=useState(false);
  const [isConfirmChecked,setIsConfirmChecked]=useState(false);
  const csrfToken = useRef(null);
  const cookieToken = useRef(null);

  let storedValue = localStorage.getItem("ScrapProcessID");
  let autoIncrementVal="";
  let newProcessIDNum="";
  
  const getCurrentDateTime=()=>{
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    return `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
  }

  const getCSRFToken =async()=>
    {
    var resTokenApiVal=auth.userData.access_token;
    console.log("acceesToken: "+resTokenApiVal);
    console.log("ConfigFileServerAPI URL: "+configJsonFile.ServerAPIUrl);
   await axios.get(configJsonFile.ServerAPIUrl,{
      headers: {
        'Content-Type': 'application/json',
        'x-api-id':  configJsonFile.ClientId,
        'Authorization':"Bearer "+resTokenApiVal              
      }
     }).then(res=> {
      console.log(res);
      csrfToken.current= res.data.requestToken;
      cookieToken.current = res.data.cookieToken;             
      //setCSRFToken(res.data.requestToken);
      //setCookieToken(res.data.cookieToken);
    })
    
  }

  // Form submit 
  const handleSubmit = async (event) => 
  {
    
    //Checking at least one general information row;
    if(rowsData.length >= 1)
    { 
    const isSubmitConfirm=window.confirm('Are you sure you want to submit this request?');
    if(isSubmitConfirm)
    {           
      event.preventDefault();
      var CurrentYear = getCurrentDateTime();
      if (storedValue == null)
      {      
        storedValue = 1;
      }
      
      // console.log("Auth User data Token: "+auth.userData.access_token);      
      var resTokenApiVal=auth.userData.access_token;      
      // Call API Start
      newProcessIDNum = Number(storedValue)+1;
      if(storedValue===1)
      {
        autoIncrementVal = String(storedValue).padStart(3,0);
      }
     else
      {      
        autoIncrementVal = String(newProcessIDNum).padStart(3,0);
      }              
      const requestId = selectedFile.length;
      if(selectedFile.length>0)
      {
        for(let i=0;i<selectedFile.length;i++){        
        // upload each file to S3 calling API here
        let Num=i+1;
        CallWebAPI(selectedFile[i],Num,resTokenApiVal, CurrentYear);               
      }
      }
      // Create JSON File
      var dictstring= JSON.stringify({      
  processInfo:{
    domainId:"supplyMangnt",
    ProcessId:configJsonFile.NewScrapProcessId,
    NewRequest: "True",
	  InstanceNumber: "",
	  AttachmentID:"Att_"+configJsonFile.NewScrapProcessId+"_"+CurrentYear+"_"+autoIncrementVal+"_"+requestId,
	  PathID:configJsonFile.NewScrapPathID
    },
    form:{       
    VendorCode:VendorCode,
    VendorName:VendorName,
    VendorEmail:VendorEmail,
    ContactName:ContactName,
    Telephone:Telephone,
    QualityManager:QualityManager,
    DateValue:DateValue,
    PWC_Representative:PWC_Representative,
    Comments:comments,       
    GeneralInformation:rowsData
    },
  //files: myAttachmentArr
  
       });  
      //alert(dictstring);
      console.log(dictstring);     
      const jsonfileObj = new Blob([dictstring], { type: 'application/json' });      
      console.log(jsonfileObj);
      let isJOSNFile="Yes"; 
      CallWebAPI(jsonfileObj,isJOSNFile,resTokenApiVal,CurrentYear);
      
      // Update Session variable to get increment num
      localStorage.setItem("ScrapProcessID", newProcessIDNum);
      // Call API End 
    }      
  }else{
    alert("Please Add at least one Part Number under General Information Section!");
    event.preventDefault();
  }
  }

  // Call API to upload files to S3
  const CallWebAPI=async(requestBody,isFileProp,getTokeVal,CurrentYear)=>
  {
    try {
      let fileNameVal="";
     // let CurrentYear = new Date().getFullYear();
      if(isFileProp==="Yes"){
        fileNameVal="JSON_"+configJsonFile.NewScrapProcessId+"_"+CurrentYear+"_"+autoIncrementVal+".json";
      } 
      else{        
        fileNameVal="ATT_"+configJsonFile.NewScrapProcessId+"_"+CurrentYear+"_"+autoIncrementVal+"_"+requestBody.name;
      } 
      //getCSRFToken();
      console.log("FileName: "+fileNameVal);
       const formData = new FormData();
       formData.append('file', requestBody);
       formData.append('fileName', fileNameVal);
       formData.append('processID', configJsonFile.NewScrapProcessId);
       formData.append('cookie', cookieToken.current);
console.log("Cookie Toke:"+cookieToken.current);
console.log("csrfToken:"+csrfToken.current);

      console.log("Attempting to send data to AWS...");
      axios.post(configJsonFile.ServerAPIUrl,formData, {
        headers: {
        'Content-Type': 'multipart/form-data',
        'x-api-id':  configJsonFile.ClientId,
        'Authorization':"Bearer "+getTokeVal,
        'RequestVerificationToken': csrfToken.current        
      }        
        }).then(res => {          
          if (res.status===201 || res.status ===200 || res.status === 202) { 
              setmodelPopupshow(true);                             
              setAPIMessage("Files are uploaded successfully to AWS S3");              
            }else{
              console.log("Status Code:"+res.status);
              console.log("Status Data:"+res.data);
            }
        });
      console.log("... Attempt completed!");
    } catch (err) {
      console.log(err);
      console.log("Error Json:"+err.toJSON());
      setAPIMessage("Failed Due to:"+err);
    }

  }

  const onClickHomeHandler=async(event)=>{      
    const isConfirmedHome=window.confirm('You might loose the data, Are you sure you want to go to home page?');
    if(isConfirmedHome){
      navigate('/');
    } 
  }
  const onClickCancelHandler=async(event)=>{  
    const isConfirmedCancel=window.confirm('You might loose the data, Are you sure you want to Cancel this request?');
    if(isConfirmedCancel){
      navigate('/');
    } 
    
  }

  const handleCheckboxChange=()=>{
    setIsChecked(!isChecked);
  }
  // const autoCloseModelPopupOnTimeout=()=>{
  //   // 10 seconds time out automatically close the model-popup and redirect to home page.
  //   setTimeout(function()
  //   {
  //     navigate('/');
  //   }, 10000);
  // }
  const handleOkButtonModelPopup=()=>{
    navigate('/');
    setmodelPopupshow(false);
  }

  const handleChangeConfirmCheckbox=()=>{
    setIsConfirmChecked(!isConfirmChecked);
  }

  if (auth && auth.userData) {
  return (

    <form onSubmit={handleSubmit}>
      
    <div class="container"> 
<div class="row">
<div class="col-8 p-0">
  <img src={imgLogo} alt="Logo" width="100%" height="80%"/>
</div>
<div class="col-4 p-0">
  <img src={rightLogo} alt="Logo" width="100%" height="80%"/>
</div>
</div>
<div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Vendor Information</h5></div></div>  
  <div class="marginLeft" Id="InitialFields">
    <div class="row">
    <div class="col-2">
      <label for="vendorCode">Vendor Code<label style={{color:'red'}}>*</label></label>
    </div>
    <div class="col-4">
      <input type="number" 
      value={VendorCode} 
      onChange={(e) => setVendorCode(e.target.value)} 
      placeholder="Enter Vendor code" required/>
    </div>
    <div class="col-2">
      <label for="vendorName">Vendor Name<label style={{color:'red'}}>*</label></label>
    </div>
    <div class="col-4">
      <input type="text" 
      value={VendorName} 
      onChange={(e) => setVendorName(e.target.value)} 
      placeholder="Enter Vendor name" required/>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <label for="vendorEmail">Vendor Email<label style={{color:'red'}}>*</label></label>
    </div>
    <div class="col-4">
      <input type="text" 
      value={VendorEmail} 
      onChange={(e) => setVendorEmail(e.target.value)} 
      placeholder="Enter Vendor email" required/>
    </div>
    <div class="col-2">
      <label for="ContactName">Vendor Contact Name<label style={{color:'red'}}>*</label></label>
    </div>
    <div class="col-4">
      <input type="text" 
      value={ContactName} 
      onChange={(e) => setContactName(e.target.value)} 
      placeholder="Enter Contact name" required/>
    </div>
  </div>

  <div class="row">
    <div class="col-2">
      <label for="Telephone">Telephone</label>
    </div>
    <div class="col-4">
      <input type="text" 
      value={Telephone} 
      onChange={(e) => setTelephone(e.target.value)} 
      placeholder="Enter Phone number"/>
    </div>
    <div class="col-2">
      <label for="Date">Date</label>
    </div>
    <div class="col-4">
      <input type="Date" 
      value={DateValue} 
      onChange={(e) => setDateValue(e.target.value)} 
      placeholder="Enter Date" required readOnly/>      
    </div>    
  </div>

  <div class="row">
    <div class="col-2">
      <label for="PWC_Representative">P&WC Representative(DQR, SQAR or TPSI)</label>
    </div>
    <div class="col-4">
      <input type="text" 
      value={PWC_Representative} 
      onChange={(e) => setPWC_Representative(e.target.value)} 
      placeholder="Enter P&WC representative"/>
    </div>
    <div class="col-2">
      <label for="QualityManager">Quality Manager at Supplier</label>
    </div>
    <div class="col-4">
      <input type="text" 
      value={QualityManager} 
      onChange={(e) => setQualityManager(e.target.value)} 
      placeholder="Enter Quality Manager"/>
    </div>
  </div>
    <div class="row">
    <div class="col-12">
      <label for="Is it already mutilated?">Check the box if the part(s) have already been mutilated</label> &nbsp;&nbsp;  
      <input type="checkbox" 
      value={isChecked} 
      onChange={handleCheckboxChange} 
      />
    </div>
    </div>
    
  </div>  
  
  <GeneralInformationTable rowsData={rowsData} setRowsData={setRowsData}/>

  <div class="row">
    <div class="col-2">
      <label for="Coments">Comments</label>
    </div>
    <div class="col-10">
      <textarea class="VendorComments"id="Comments" name="Comments" value={comments} placeholder="Write something.." onChange={(e) => setComments(e.target.value)} ></textarea>
    </div>
    </div>
  <div class="row">
  <div class="col-2">
      <label for="subject">Attachments</label>
    </div>
    <div class="col-10">
    <input type="file" onChange={(e) => setSelectedFile(e.target.files?e.target.files:null )} multiple/>    
    </div>    
  </div>

    <div class="row">
  <div>
    <input type="checkbox" value={isConfirmChecked} style={{ color:'red'}} onChange={handleChangeConfirmCheckbox} required />&nbsp;&nbsp; <label  style={{color:'red'}}>I confirm this form and attached document(s) DO NOT contain any technical information subject to EAR, ITAR or ECL</label>
  </div>
  </div>

  <div class="row">  
    <div class="col-4">
    <input type="submit" value="Submit" /> &nbsp;
    <input type="button" value="Home" onClick={onClickHomeHandler} /> &nbsp;
    <input type="button" value="Cancel" onClick={onClickCancelHandler} />
    </div>
  </div>
  <div class="row">
  <div class="col-10 text-success">    
     <Modal
        show={modelPopupshow}
        onHide={handleOkButtonModelPopup}
        backdrop="static"
        keyboard={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
          <Modal.Title> Scrap Evaluation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <p> Your Scrap Evaluation request has been submitted.</p>
        <p> You will receive an email with the request information and details for tracking purposes.</p>
        <p> Please reach out to your buyer in case of any issues or concerns regarding your request.</p>
        <p> Click <strong><mark>OK</mark></strong> to return to the home page.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleOkButtonModelPopup}>
            OK
          </Button>          
        </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
</form>
  )
}else{
  return <div>Not logged in! Try to refresh to be redirected to login page.</div>;
}
}

export default NewScrapEvaluation;
